import type { VFC } from 'react'
import { QuasiTabs } from '@opallabs/lapidary'
import { WeekViewMode } from '../../types'
import { useWeekViewSettings } from '../../WeekViewSettingsContext'

const options = [
  { label: 'Moments', value: WeekViewMode.Moment },
  { label: 'Content', value: WeekViewMode.Content },
]

export const ViewModeToggle: VFC = () => {
  const { viewMode, setViewMode } = useWeekViewSettings()

  return (
    <QuasiTabs
      aria-label="What the week shows"
      value={viewMode}
      onValueChange={(next) => setViewMode(next as WeekViewMode)}
    >
      {options.map((option) => (
        <QuasiTabs.Option key={option.value} value={option.value}>
          {option.label}
        </QuasiTabs.Option>
      ))}
    </QuasiTabs>
  )
}
